import { render } from "./BrandSelect.vue?vue&type=template&id=1d4f3451&ts=true"
import script from "./BrandSelect.vue?vue&type=script&lang=ts"
export * from "./BrandSelect.vue?vue&type=script&lang=ts"

import "./BrandSelect.vue?vue&type=style&index=0&id=1d4f3451&lang=scss"

import exportComponent from "/drone/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__